import { __assign } from "tslib";
import get from 'lodash/get';
import { CommissionStatusCodes } from '../../../../types/commissions';
var commissionShopThumbAdapter = function (props) {
    var status = get(props, 'deviation.commission.status');
    var price = get(props, 'deviation.commission.pointsCost');
    var textContent = get(props, 'deviation.textContent', get(props, 'deviation.commission.textContent'));
    var disabled = status !== CommissionStatusCodes.STATUS_ACTIVE;
    var dollarsCost = get(props, 'deviation.commission.dollarsCost');
    return __assign(__assign({}, props), { textContent: textContent,
        disabled: disabled, disabledLabel: 'deviationview.commission.commissionClosed', price: price, priceLabel: 'shop.thumb.points', dollarsCost: dollarsCost });
};
export default commissionShopThumbAdapter;
//# sourceMappingURL=commission.js.map